import React from "react";

function Introduction() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <h1 className="page-title">Become a Partner</h1>
          <p className="page-description">
            Get in touch with us & we will get back to you at earliest.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Introduction;
